import { forwardRef, HTMLAttributes } from "react";

export type Props = HTMLAttributes<HTMLSpanElement> & {
  /** The count to display */
  count: number;
  /** Additional CSS classes */
  className?: string;
  /** Test ID for testing */
  "data-testid"?: string;
};

/**
 * Base count badge component with no styling.
 * Displays a numeric count, typically used for notifications.
 * Returns null when count is 0.
 */
export const CountBadgeBase = forwardRef<HTMLSpanElement, Props>(
  ({ count, className, "data-testid": testId = "count-badge-base", ...props }, ref) => {
    if (count === 0) return null;

    return (
      <span
        ref={ref}
        className={className}
        data-testid={testId}
        data-count={count}
        {...props}
      >
        {count}
      </span>
    );
  }
);

CountBadgeBase.displayName = "CountBadgeBase";

